import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

export const ProblemSection = () => (
  <section id="problema" className="bg-[#121212] py-24 sm:py-32">
    <div className="mx-auto max-w-4xl px-6 lg:px-8">
      <SectionHeading
        eyebrow="Il problema"
        title="La tua fede non finisce la domenica."
        testid="problem-heading"
      />
      <Reveal>
        <div className="space-y-4 text-base leading-relaxed text-[#B8B8B8] sm:text-lg">
          <p>Puoi frequentare la tua chiesa.</p>
          <p>Puoi ascoltare una predicazione.</p>
          <p>Puoi leggere la Bibbia.</p>
          <p className="pt-2 font-semibold text-white">
            Ma cosa succede quando arriva il lunedì?
          </p>
          <p>
            Quando devi affrontare le paure, le tentazioni, le difficoltà
            familiari, le relazioni, il lavoro e le abitudini che vorresti
            cambiare?
          </p>
          <p>
            La fede non è fatta per essere vissuta soltanto durante un incontro
            settimanale.
          </p>
          <p>
            Tempio Vivo nasce per aiutarti a vivere ciò in cui credi ogni
            giorno.
          </p>
        </div>
      </Reveal>
      <Reveal delay={0.15} className="mt-12 text-center">
        <p className="font-display text-2xl font-semibold uppercase tracking-wide text-[#C9A45C] sm:text-3xl">
          Dalla Parola all'azione.
          <br />
          Dalla domenica alla quotidianità.
        </p>
        <blockquote
          data-testid="problem-verse"
          className="mx-auto mt-10 max-w-xl border-l-2 border-[#C9A45C] pl-6 text-left"
        >
          <p className="font-display text-xl italic text-white">
            «La fede senza le opere è morta.»
          </p>
          <cite className="mt-2 block text-sm not-italic uppercase tracking-widest text-[#8F7138]">
            Giacomo 2:17
          </cite>
        </blockquote>
      </Reveal>
    </div>
  </section>
);
